import { Box, Table } from '@factorialco/deprecated-design-system'

import { QuotePricingLineItem } from 'modules/finance/components/Quotes/utils'

import AddItemButton from './AddItemButton'
import ItemRowProduct from './ItemRowProduct'
import ItemRowTimeAndMaterial from './ItemRowTimeAndMaterial'

interface BodyProps {
  standaloneItems?: QuotePricingLineItem[]
  currency: string
  isDraftStatus: boolean
  isProductQuote: boolean
  isJobCatalogTreeEnabled: boolean
  onUpdateStandaloneItem?: (itemId: number, updates: Partial<QuotePricingLineItem>) => void
  onAddStandaloneItem?: (itemType: 'role' | 'simple') => void
  onDeleteStandaloneItem?: (itemId: number) => void
  legalEntityCountry: string | undefined
}

const Body = ({
  standaloneItems = [],
  currency,
  isDraftStatus,
  isProductQuote,
  isJobCatalogTreeEnabled,
  onUpdateStandaloneItem,
  onAddStandaloneItem,
  onDeleteStandaloneItem,
  legalEntityCountry,
}: BodyProps) => {
  const generateItemList = (items: QuotePricingLineItem[]) => {
    if (isProductQuote) {
      return items.map((item) => (
        <ItemRowProduct
          key={item.id}
          item={item}
          legalEntityCountry={legalEntityCountry}
          currency={currency}
          isDraftStatus={isDraftStatus}
          onUpdate={(updates) => onUpdateStandaloneItem?.(item.id, updates)}
          onDelete={() => onDeleteStandaloneItem?.(item.id)}
        />
      ))
    } else {
      return items.map((item) => (
        <ItemRowTimeAndMaterial
          key={item.id}
          item={item}
          currency={currency}
          isDraftStatus={isDraftStatus}
          isJobCatalogTreeEnabled={isJobCatalogTreeEnabled}
          onUpdate={(updates: Partial<QuotePricingLineItem>) =>
            onUpdateStandaloneItem?.(item.id, updates)
          }
          onDelete={() => onDeleteStandaloneItem?.(item.id)}
        />
      ))
    }
  }
  return (
    <Table.Body>
      {generateItemList(standaloneItems)}
      {onAddStandaloneItem && isDraftStatus && (
        <Table.Row>
          <Table.Cell colSpan={2}>
            <Box flexDirection="row" justifyContent="flexStart">
              <AddItemButton
                isProductQuote={isProductQuote}
                onAddRole={() => onAddStandaloneItem('role')}
                onAddProduct={() => onAddStandaloneItem('simple')}
              />
            </Box>
          </Table.Cell>
          <Table.Cell colSpan={14} />
        </Table.Row>
      )}
    </Table.Body>
  )
}

export default Body
